// В.2.h-rebalance: ИИ-Проект «Бессмертный» (liv_ii_proekt_bessmertnyy, Герой Лив Лайф, 2/0/16).
//
// Пассивка (новая): «Когда умирает любой союзный юнит, Герой получает
//                    max_hp этого юнита, но не больше своего max_hp».
//   - Триггер on_unit_died через registerOnUnitDiedExtraHandler.
//   - Фильтр: deadUnit.ownerId === Бессмертного.ownerId, deadUnit.type === 'unit'.
//   - Эффект: healUnit(hero, deadUnit.base.hp, source=bessmertnyy_passive).
//     cap по max_hp Героя реализован в healUnit (cur ≤ base).
//   - Молчание Бессмертного блокирует.
//   - НЕ срабатывает на смерть Героя (deadUnit.type === 'hero').
//   - НЕ срабатывает на смерть вражеских юнитов.
//
// УДАЛЕНО (по сравнению с В.2.g):
//   - Старая блокирующая пассивка «не может быть исцелён никем кроме Донора /
//     своей активки» — снята полностью. Бессмертный теперь лечится обычно
//     любым источником.
//   - Триггер on_damage_taken «при уроне → призыв Донора».
//   - Флаг state.players[idx].bessmertnyDonorThisTurn (более не используется).
//
// Активка (без изменений) — bessmertnyy_active.js: уничтожь своего юнита,
// добавь его current_hp к ХП Героя (cap по max_hp).

import { healUnit } from './heal.js';
import { registerImplementedAbility } from './warn-unimplemented.js';
import { registerOnUnitDiedExtraHandler } from '../deus/hooks.js';

export const HERO_ID = 'liv_ii_proekt_bessmertnyy';
const LABEL = 'Бессмертный';
const SOURCE_ID = 'liv_ii_proekt_bessmertnyy_passive';

registerImplementedAbility(HERO_ID, 'passive');

registerOnUnitDiedExtraHandler((state, payload) => {
  if (!state || !payload) return;
  const dead = payload.card;
  if (!dead || dead.type !== 'unit') return;
  const ownerIdx = payload.ownerIdx;
  if (ownerIdx == null) return;
  const owner = state.players?.[ownerIdx];
  if (!owner?.hero) return;
  if (owner.hero.id !== HERO_ID) return;
  if (owner.hero.hp <= 0) return;
  // Молчание Бессмертного блокирует пассивку.
  if (owner.hero.current?.silenced) return;
  if (owner.hero.silenceSources && owner.hero.silenceSources.size > 0) return;
  const heal = dead.base?.hp ?? 0;
  if (heal <= 0) return;
  state.log?.add(
    `🩹 ${LABEL} [${owner.name}]: ${dead.name_ru} погиб → +${heal} ХП Герою (cap по max)`
  );
  healUnit(state, owner.hero, heal, { id: SOURCE_ID, name_ru: LABEL, type: 'hero' });
});
